import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { KTIcon } from '../../../../helpers/components/KTIcon'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../redux/store'
import Box from '../../../../../components/Box'
import { Helpers } from '../../../../../helpers/Helpers'

const SidebarMenuMain = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const [searchTerm, setSearchTerm] = useState<string>('');

    const checkAllownce = (_text: string) => {
        if (!Helpers.isEmpty(searchTerm)) {
            return auth.user.user?.data.authorizedMenus.find(x => x.menuName.toLowerCase().includes(searchTerm.toLowerCase()) && x.menuName.startsWith(_text)) !== undefined;
        }

        return auth.user.user?.data.authorizedMenus.find(x => x.menuName.startsWith(_text));
    }

    return (
        <React.Fragment>
            {/* <SidebarMenuItem
                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/dashboard'
                icon='element-11'
                title={'Dashboard'}
                fontIcon='bi-app-indicator'
            />

            {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Harita") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/map' icon='element-11' title={'Harita'} fontIcon='bi-app-indicator' />}

            <SidebarMenuItemWithSub
  isCustomActive={!Helpers.isEmpty(searchTerm)}
                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/general'
                title='Genel İşlemler'
                fontIcon='bi-archive'
                icon='element-plus'
            >
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Genel İşlemler > GPS Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/general/creategps' title='GPS Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Genel İşlemler > Araç Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/general/createcar' title='Araç Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Genel İşlemler > Sürücü Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/general/createdriver' title='Sürücü Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Genel İşlemler > Bölge Tipi Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/general/createareatype' title='Bölge Tipi Tanımlama' hasBullet={true} />}
            </SidebarMenuItemWithSub>

            <SidebarMenuItemWithSub
  isCustomActive={!Helpers.isEmpty(searchTerm)}
                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/reports'
                title='Raporlar'
                fontIcon='bi-archive'
                icon='element-plus'
            >
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Raporlar > Günlük Rapor") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/reports/dailyreport' title='Günlük Rapor' hasBullet={true} />}
            </SidebarMenuItemWithSub>

            <SidebarMenuItemWithSub
  isCustomActive={!Helpers.isEmpty(searchTerm)}
                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings'
                title='Ayarlar'
                fontIcon='bi-archive'
                icon='element-plus'
            >
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Ayarlar > Stok Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings/createstock' title='Stok Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Ayarlar > Şirket Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings/createcompany' title='Şirket Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Ayarlar > Rol Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings/createrole' title='Rol Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Ayarlar > Araç Tipi Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings/createvehicletype' title='Araç Tipi Tanımlama' hasBullet={true} />}
                {auth.user.user?.data.authorizedMenus.find(x => x.menuName == "Ayarlar > Kullanıcı Tanımlama") && <SidebarMenuItem isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/settings/createuser' title='Kullanıcı Tanımlama' hasBullet={true} />}
            </SidebarMenuItemWithSub> */}

            <Box>
                <div className='d-flex align-items-center position-relative my-1'>
                    <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                    <input
                        type='text'
                        data-kt-user-table-filter='search'
                        className='form-control form-control-solid ps-14'
                        placeholder='Ara...'
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value)
                        }}
                    />

                    {
                        !Helpers.isEmpty(searchTerm) && (
                            <div style={{ position: 'absolute', right: 0, marginRight: 15, justifyContent: 'center', display: 'flex' }}>
                                <i onClick={() => setSearchTerm('')} className="actionIcon fs-2 fa fa-times text-dark" />
                            </div>
                        )
                    }
                </div>
            </Box>

            {
                checkAllownce("Dashboard") && (
                    <SidebarMenuItem
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        to='/dashboard'
                        title='Dashboard'
                        faIcon='fa-dashboard'
                    />
                )
            }

            {
                checkAllownce("Harita") && (
                    <SidebarMenuItem
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        to='/map'
                        title='Harita'
                        faIcon='fa-map'
                    />
                )
            }

            {
                checkAllownce("Pazarlama >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Pazarlama'
                        faIcon='fa-gift'
                    >
                        {
                            checkAllownce("Pazarlama > Karşılamalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Karşılamalar'
                                >
                                    {
                                        checkAllownce("Pazarlama > Karşılamalar > Antrepo Tahliye") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/welcomeout/list'
                                                title='Antrepo Tahliye'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Pazarlama > Karşılamalar > Antrepo Yükleme") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/welcomein/list'
                                                title='Antrepo Yükleme'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("Pazarlama > Görüşmeler") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/meeting/list'
                                    title='Görüşmeler'
                                />
                            )
                        }

                        {
                            checkAllownce("Pazarlama > Teklifler") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Teklifler'
                                >
                                    {
                                        checkAllownce("Pazarlama > Teklifler > Antrepo Teklifleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/antrepooffer/list'
                                                title='Antrepo Teklifleri'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Kargo Modülü >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Kargo Modülü'
                        faIcon='fa-truck-fast'
                    >
                        {
                            checkAllownce("Kargo Modülü > Yurtiçi Kargo") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Yurtiçi Kargo'
                                >
                                    {
                                        checkAllownce("Kargo Modülü > Yurtiçi Kargo > Siparişler") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/yurticicargo/list'
                                                title='Siparişler'
                                            />
                                        )
                                    }


                                    {
                                        checkAllownce("Kargo Modülü > Yurtiçi Kargo > Anlaşma Şablonu") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/yurticicargoagreementscheme/list'
                                                title='Anlaşma Şablonu'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Yurtiçi Kargo > Anlaşma") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/yurticicargoagreement/list'
                                                title='Anlaşma'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Yurtiçi Kargo > Gider Mutabakatı") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/yurticimutabakat/list'
                                                title='Gider Mutabakatı'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("Kargo Modülü > Nakliye") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Nakliye'
                                >
                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Siparişler") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/ambar/list'
                                                title='Siparişler'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Anlaşma Şablonu") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/ambaragreementscheme/list'
                                                title='Anlaşma Şablonu'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Anlaşma") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/ambaragreement/list'
                                                title='Anlaşma'
                                            />
                                        )
                                    }

                                    {/* Sabit Gelir Dağıtımı Nakliye'de, Anlaşma'dan sonra (09.10.2026): bir nevi anlaşma. */}
                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Sabit Gelir Dağıtımı") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/sabitgelir/list'
                                                title='Sabit Gelir Dağıtımı'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Ek Mesai Talepleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/mesaitalebi/list'
                                                title='Ek Mesai Talepleri'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Atanacak Mesailer") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/mesaiatama'
                                                title='Atanacak Mesailer'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Kargo Modülü > Nakliye > Seferler") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/ambarvoyage/list'
                                                title='Seferler'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Antrepo Modülü >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Antrepo Modülü'
                        faIcon='fa-folder'
                    >
                        {
                            checkAllownce("Antrepo Modülü > Antrepo Girişi") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/antrepoin/list'
                                    title='Antrepo Girişi'
                                />
                            )
                        }

                        {
                            checkAllownce("Antrepo Modülü > Antrepo Çıkışı") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/antrepoout/list'
                                    title='Antrepo Çıkışı'
                                />
                            )
                        }

                        {/* {
                            checkAllownce("Antrepo Modülü > Siparişler") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/landorder/list'
                                    title='Siparişler'
                                />
                            )
                        } */}

                        {
                            checkAllownce("Antrepo Modülü > Anlaşmalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Anlaşmalar'
                                >
                                    {
                                        checkAllownce("Antrepo Modülü > Anlaşmalar > Fiyat Listesi") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/price/list'
                                                title='Fiyat Listesi'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Antrepo Modülü > Anlaşmalar > Anlaşma Kayıt") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/agreement/list'
                                                title='Anlaşma Kayıt'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("Antrepo Modülü > Tanımlamalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Tanımlamalar'
                                >
                                    {
                                        checkAllownce("Antrepo Modülü > Tanımlamalar > Antrepo Tanımlama") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/antrepo/list'
                                                title='Antrepo Tanımları'
                                            />
                                        )
                                    }

                                    {/* {
                                        checkAllownce("Antrepo Modülü > Tanımlamalar > Sürücü Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/driver/list'
                                                title='Sürücü Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Antrepo Modülü > Tanımlamalar > Konteyner Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
to='/container/list'
                                                title='Konteyner Tanımları'
                                            />
                                        )
                                    } */}
                                </SidebarMenuItemWithSub>
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Depo Modülü >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Depo Modülü'
                        faIcon='fa-boxes'
                    >
                        {
                            checkAllownce("Depo Modülü > Tanımlamalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Tanımlamalar'
                                >
                                    {
                                        checkAllownce("Depo Modülü > Tanımlamalar > Depo Tanımlama") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/storage/list'
                                                title='Depo Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Depo Modülü > Tanımlamalar > Ürün Tanımlama") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/product/list'
                                                title='Ürün Tanımlama'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("İnsan Kaynakları >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='İnsan Kaynakları'
                        faIcon='fa-user-clock'
                    >
                        {
                            checkAllownce("İnsan Kaynakları > Tanımlamalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Tanımlamalar'
                                >
                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Personel Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/personnel/list'
                                                title='Personel Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Çalışma Saatleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/calismasaati'
                                                title='Çalışma Saatleri'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > QR Noktaları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/mesainoktasi/list'
                                                title='QR Noktaları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Özel Günler") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/ozelgun/list'
                                                title='Özel Günler'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > İzin Türleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/izinturu/list'
                                                title='İzin Türleri'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Vardiya Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/vardiyatanimi/list'
                                                title='Vardiya Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Vardiya Planları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/vardiyaplani/list'
                                                title='Vardiya Planları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("İnsan Kaynakları > Tanımlamalar > Görev Yetkileri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/gorevyetkisi'
                                                title='Görev Yetkileri'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("İnsan Kaynakları > Mesai Kayıtları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/mesaikaydi/list'
                                    title='Mesai Kayıtları'
                                />
                            )
                        }

                        {
                            checkAllownce("İnsan Kaynakları > İzin Kayıtları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/izin/list'
                                    title='İzin Kayıtları'
                                />
                            )
                        }

                        {
                            checkAllownce("İnsan Kaynakları > Vardiya Çizelgesi") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/vardiyacizelgesi'
                                    title='Vardiya Çizelgesi'
                                />
                            )
                        }

                        {
                            checkAllownce("İnsan Kaynakları > Aylık Puantaj") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/puantaj'
                                    title='Aylık Puantaj'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Uluslararası Kara >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Uluslararası Kara'
                        faIcon='fa-truck'
                    >
                        {
                            checkAllownce("Uluslararası Kara > Siparişler") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/landorder/list'
                                    title='Siparişler'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Genel Giderler >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Genel Giderler'
                        faIcon='fa-receipt'
                    >
                        {
                            checkAllownce("Genel Giderler > HGS Kayıtları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/hgsogs/list'
                                    title='HGS Kayıtları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Giderler > Yakıt Kayıtları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/yakit/list'
                                    title='Yakıt Kayıtları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Giderler > Sigorta / Kasko") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/sigorta/list'
                                    title='Sigorta / Kasko'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Genel Tanımlamalar >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Genel Tanımlamalar'
                        faIcon='fa-cog'
                    >
                        {
                            checkAllownce("Genel Tanımlamalar > Döviz Cinsi Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/currencytype/list'
                                    title='Döviz Cinsi Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Döviz Kuru Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/currencyconversion/list'
                                    title='Döviz Kuru Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Ülke Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/country/list'
                                    title='Ülke Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Şehir Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/county/list'
                                    title='Şehir Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > İlçe Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/district/list'
                                    title='İlçe Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Semt Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/neighborhood/list'
                                    title='Semt Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Sabit Tanımlamalar") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/constantcategory/list'
                                    title='Sabit Tanımlamalar'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > GTip Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/gtip/list'
                                    title='GTip Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Cihaz Stok Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/stock/list'
                                    title='Cihaz Stok Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > GPS Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/device/list'
                                    title='GPS Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Araç Cinsi Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/vehicleType/list'
                                    title='Araç Cinsi Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > GSM Stok Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/gsmstock/list'
                                    title='GSM Stok Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Araç Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/vehicle/list'
                                    title='Araç Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Sürücü Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/driver/list'
                                    title='Sürücü Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Konteyner Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/container/list'
                                    title='Konteyner Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > PO Eşleştirme") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/companypo/list'
                                    title='PO Eşleştirme'
                                />
                            )
                        }

                        {
                            checkAllownce("Genel Tanımlamalar > Proje - Bölge Eşleştirme") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/projectregion/list'
                                    title='Proje - Bölge Eşleştirme'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Ön Muhasebe >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Ön Muhasebe'
                        faIcon='fa-calculator'
                    >
                        {
                            checkAllownce("Ön Muhasebe > Hesaplama") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/calculate/list'
                                    title='Hesaplama'
                                />
                            )
                        }

                        {
                            checkAllownce("Ön Muhasebe > Faturalanacaklar") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/willinvoiced/list'
                                    title='Faturalanacaklar'
                                />
                            )
                        }

                        {
                            checkAllownce("Ön Muhasebe > Fiş / Faturalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Fiş / Faturalar'
                                >
                                    {
                                        checkAllownce("Ön Muhasebe > Fiş / Faturalar > Satış Faturaları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/saleinvoice/list'
                                                title='Satış Faturaları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > Fiş / Faturalar > Alış Faturaları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/purchaseinvoice/list'
                                                title='Alış Faturaları'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("Ön Muhasebe > İşlemler") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='İşlemler'
                                >
                                    {
                                        checkAllownce("Ön Muhasebe > İşlemler > Kasa Hareketleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/casemovement/list'
                                                title='Kasa Hareketleri'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > İşlemler > Banka Hareketleri") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/bankaccounttransaction/list'
                                                title='Banka Hareketleri'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > İşlemler > J&J Ödeme Durumu") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/jnjpayment/list'
                                                title='J&J Ödeme Durumu'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }

                        {
                            checkAllownce("Ön Muhasebe > Tanımlamalar") && (
                                <SidebarMenuItemWithSub
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    title='Tanımlamalar'
                                >
                                    {
                                        checkAllownce("Ön Muhasebe > Tanımlamalar > Firma Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/company/list'
                                                title='Firma Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > Tanımlamalar > Banka Hesap Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/bankaccount/list'
                                                title='Banka Hesap Tanımları'
                                            />
                                        )
                                    }


                                    {
                                        checkAllownce("Ön Muhasebe > Tanımlamalar > Kasa Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/case/list'
                                                title='Kasa Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > Tanımlamalar > Hizmet Kalemi Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/service/list'
                                                title='Hizmet Kalemi Tanımları'
                                            />
                                        )
                                    }

                                    {
                                        checkAllownce("Ön Muhasebe > Tanımlamalar > Tevkifat Türü Tanımları") && (
                                            <SidebarMenuItem
                                                isCustomActive={!Helpers.isEmpty(searchTerm)}
                                                to='/withholding/list'
                                                title='Tevkifat Türü Tanımları'
                                            />
                                        )
                                    }
                                </SidebarMenuItemWithSub>
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Raporlar >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Raporlar'
                        faIcon='fa-file'
                    >
                        {
                            checkAllownce("Raporlar > Ek-83 Raporu") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/report/ek83reportlist'
                                    title='Ek-83 Raporu'
                                />
                            )
                        }

                        {
                            checkAllownce("Raporlar > Günlük Rapor") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/report/dailyreportlist'
                                    title='Günlük Rapor'
                                />
                            )
                        }

                        {
                            checkAllownce("Raporlar > Günlük Km & Yakıt Raporu") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/report/dailykmandfuelreportlist'
                                    title='Günlük Km & Yakıt Raporu'
                                />
                            )
                        }

                        {
                            checkAllownce("Raporlar > Sürücü Rölanti Raporu") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/report/idlereport'
                                    title='Sürücü Rölanti Raporu'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }

            {
                checkAllownce("Ayarlar >") && (
                    <SidebarMenuItemWithSub
                        isCustomActive={!Helpers.isEmpty(searchTerm)}
                        title='Ayarlar'
                        faIcon='fa-cog'
                    >
                        {
                            checkAllownce("Ayarlar > Banka H. Eşleşme") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/bankaccounttransactionmatchdefinition/list'
                                    title='Banka H. Eşleşme'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Entegrasyon Ayarları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/integrationsetting/list'
                                    title='Entegrasyon Ayarları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > İş Kuyruğu") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/jobqueue/list'
                                    title='İş Kuyruğu'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Kullanıcı Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/user/list'
                                    title='Kullanıcı Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Rol Tanımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/role/list'
                                    title='Rol Tanımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Evrak Tasarımları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/document/list'
                                    title='Evrak Tasarımları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Veri Ayarları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/datasetting/list'
                                    title='Veri Ayarları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Toplu Fiyat Güncelleme") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/bulkprice/list'
                                    title='Toplu Fiyat Güncelleme'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Eskalasyon Dağılımı") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/escalation/list'
                                    title='Eskalasyon Dağılımı'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Mail Şablonları") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/mailsablonu/list'
                                    title='Mail Şablonları'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Mobil Sürüm") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/mobilsurum/ayar'
                                    title='Mobil Sürüm'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Otomatik Faturalama") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/otomatikfatura/list'
                                    title='Otomatik Faturalama'
                                />
                            )
                        }

                        {
                            checkAllownce("Ayarlar > Yurtiçi Gider Mutabakatı") && (
                                <SidebarMenuItem
                                    isCustomActive={!Helpers.isEmpty(searchTerm)}
                                    to='/yurticimutabakat/ayar'
                                    title='Yurtiçi Gider Mutabakatı'
                                />
                            )
                        }
                    </SidebarMenuItemWithSub>
                )
            }
        </React.Fragment >
    )
}

export { SidebarMenuMain }
